import { render, staticRenderFns } from "./headerMessageBuy.vue?vue&type=template&id=377175c8"
import script from "./headerMessageBuy.vue?vue&type=script&lang=js"
export * from "./headerMessageBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports